import React, { useEffect,useState } from 'react';
import './App.css';
import MascotTooltip from './MascotTooltip';
import { BarChart, Bar, XAxis, YAxis, Tooltip as ChartTooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';

const fixedCategories = ['觀察', '解釋', '定義', '其他'];

// 在檔案最上方加載 SVG
const cloudSVG = (
  <svg width="120" height="60" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',top:0,left:0,zIndex:0,opacity:0.5}}>
    <ellipse cx="60" cy="40" rx="60" ry="20" fill="#fff" />
    <ellipse cx="30" cy="30" rx="20" ry="12" fill="#fff" />
    <ellipse cx="90" cy="30" rx="20" ry="12" fill="#fff" />
  </svg>
);
const starSVG = (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',top:10,right:40,zIndex:1,opacity:0.7}}>
    <polygon points="16,2 20,12 31,12 22,19 25,30 16,23 7,30 10,19 1,12 12,12" fill="#ffe066" />
  </svg>
);
const rainbowSVG = (
  <svg width="180" height="80" viewBox="0 0 180 80" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position:'absolute',bottom:0,right:0,zIndex:0,opacity:0.6}}>
    <ellipse cx="90" cy="80" rx="80" ry="30" fill="#fbc2eb" />
    <ellipse cx="90" cy="80" rx="65" ry="24" fill="#a6c1ee" />
    <ellipse cx="90" cy="80" rx="50" ry="18" fill="#fffbe7" />
  </svg>
);

export default function App() {
  const [isTeacher, setIsTeacher] = useState(false);
  const [topics, setTopics] = useState([]);
  const [currentTopicIndex, setCurrentTopicIndex] = useState(0);
  const topic = topics[currentTopicIndex] || { categories: fixedCategories, questions: [] };
  const [tab, setTab] = useState('全部問題');
  const [newTopicTitle, setNewTopicTitle] = useState('');
  const [newTopicDesc, setNewTopicDesc] = useState('');
  const [studentName, setStudentName] = useState('');
  const [studentQuestion, setStudentQuestion] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [mascotTip, setMascotTip] = useState({ show: false, tip: '' });
  const [isAddingTopic, setIsAddingTopic] = useState(false);
  const [aiSuggesting, setAISuggesting] = useState(false);

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => setToast({ show: false, message: '', type: '' }), 3000);
  };

  const handleSubmitQuestion = async () => {
    if (!studentName.trim()) {
      showToast('請輸入你的名字', 'error');
      return;
    }
    if (!studentQuestion.trim()) {
      showToast('請輸入問題內容', 'error');
      return;
    }
    if (studentQuestion.length > 200) {
      showToast('問題長度不能超過200字', 'error');
      return;
    }

    setIsSubmitting(true);
    const newQ = {
      name: studentName,
      content: studentQuestion,
      categories: [],
      topic_id: topic.id,
    };

    try {
      const response = await fetch('/api/questions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newQ),
      });

      const saved = await response.json();

      const updatedTopics = topics.map((t) => {
        if (t.id === topic.id) {
          return {
            ...t,
            questions: [...(t.questions || []), {
              ...saved,
              time: new Date(saved.created_at).toLocaleString('zh-TW')
            }],
          };
        }
        return t;
      });

      setTopics(updatedTopics);
      setStudentName('');
      setStudentQuestion('');
      showToast('問題提交成功！');
    } catch (err) {
      console.error('提交問題失敗:', err);
      showToast('提交失敗，請重試', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  const questions = topic?.questions || [];
  const filterQuestions =
    tab === '全部問題'
      ? questions
      : tab === '未分類'
      ? questions.filter(q => q.categories.length === 0)
      : questions.filter(q => q.categories.includes(tab));

  const sortedQuestions = [...filterQuestions].sort((a, b) => {
    if (a.featured === b.featured) return 0;
    return a.featured ? -1 : 1;
  });

      const handleModalSubmit = async () => {
        if (!newTopicTitle.trim()) return;
      
        try {
          const response = await fetch('/api/topics', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              title: newTopicTitle,
              description: newTopicDesc,
            }),
          });
      
          const savedTopic = await response.json();
      
          const newTopic = {
            ...savedTopic,
            categories: fixedCategories,
            questions: [],
          };
      
          const updated = [...topics, newTopic];
          setTopics(updated);
          setCurrentTopicIndex(updated.length - 1); // 切換到新增的那筆
          setNewTopicTitle('');
          setNewTopicDesc('');
          setIsAddingTopic(false);
        } catch (err) {
          console.error('❌ 新增活動失敗:', err);
        }
      };
      

  const handleAIClassify = () => {
    const updatedQuestions = questions.map(q => ({
      ...q,
      categories: q.categories.length ? q.categories : ['觀察'],
    }));
    const updatedTopics = [...topics];
    updatedTopics[currentTopicIndex].questions = updatedQuestions;
    setTopics(updatedTopics);
  };

  const handleCategoryChange = (qId, cat) => {
    const updatedTopics = [...topics];
    const topicQuestions = updatedTopics[currentTopicIndex].questions;
    const idx = topicQuestions.findIndex(q => q.id === qId);
    if (idx === -1) return;
    const q = topicQuestions[idx];
    q.categories = q.categories.includes(cat)
      ? q.categories.filter(c => c !== cat)
      : [...q.categories, cat];
    setTopics(updatedTopics);
  };
   // 🔄 載入後端資料
   useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await fetch('/api/topics');
        const data = await response.json();
  
        // 防呆：如果不是数组，直接返回空数组
        if (!Array.isArray(data)) {
          setTopics([]);
          return;
        }
  
        const normalized = data.map(t => ({
          ...t,
          questions: t.questions || [],
          categories: fixedCategories, // 固定分類
        }));
  
        setTopics(normalized);
      } catch (err) {
        console.error('載入探究活動失敗:', err);
        setTopics([]); // 防止 topics 变成 undefined
      }
    };
  
    fetchTopics();
  }, []);
  
  const handleToggleFeatured = async (qId) => {
    const updatedTopics = [...topics];
    const topicQuestions = updatedTopics[currentTopicIndex].questions;
    const idx = topicQuestions.findIndex(q => q.id === qId);
    if (idx === -1) return;
    const q = topicQuestions[idx];
    const newFeatured = !q.featured;
    q.featured = newFeatured;
    setTopics(updatedTopics);
    try {
      await fetch(`/api/questions/${q.id}/featured`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ featured: newFeatured }),
      });
    } catch (err) {
      showToast('精選狀態同步失敗', 'error');
    }
  };

  function StatisticsPanel({ questions }) {
    // 分類統計
    const categoryStats = fixedCategories.map(cat => ({
      name: cat,
      value: questions.filter(q => q.categories.includes(cat)).length
    }));
    // 精選統計
    const featuredCount = questions.filter(q => q.featured).length;
    return (
      <div className="card">
        <h2>統計圖表</h2>
        <div style={{ width: '100%', height: 220 }}>
          <ResponsiveContainer>
            <BarChart data={categoryStats}>
              <XAxis dataKey="name" />
              <YAxis allowDecimals={false} />
              <ChartTooltip />
              <Bar dataKey="value" fill="#8884d8" />
            </BarChart>
          </ResponsiveContainer>
        </div>
        <div style={{ width: '100%', height: 220 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie data={categoryStats} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={60} label>
                {categoryStats.map((entry, idx) => (
                  <Cell key={`cell-${idx}`} fill={["#8884d8","#82ca9d","#ffc658","#ff7f50"][idx % 4]} />
                ))}
              </Pie>
              <Legend />
              <ChartTooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
        <div>精選問題數：<b>{featuredCount}</b></div>
      </div>
    );
  }

  useEffect(() => {
    if (currentTopicIndex >= topics.length) {
      setCurrentTopicIndex(topics.length > 0 ? topics.length - 1 : 0);
    }
  }, [topics, currentTopicIndex]);

  const handleAISuggest = async () => {
    setAISuggesting(true);
    setMascotTip({ show: true, tip: 'AI 正在思考建議中...' });
    try {
      const res = await fetch('/api/questions/ai-suggest', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          topicTitle: topic.title,
          topicDesc: topic.description,
          question: studentQuestion
        })
      });
      const data = await res.json();
      setMascotTip({ show: true, tip: `AI建議：${data.suggest}\n分類方向：${data.category}` });
      // 可選：提供一鍵套用建議
      // setStudentQuestion(data.suggest);
    } catch (err) {
      setMascotTip({ show: true, tip: 'AI 建議失敗，請稍後再試' });
    } finally {
      setAISuggesting(false);
    }
  };

  return (
    <>
      <header className="main-header" style={{position:'relative',overflow:'hidden'}}>
        {cloudSVG}
        {starSVG}
        <div className="header-content">
          <img src={process.env.PUBLIC_URL + '/owl.gif'} alt="logo" className="header-logo" />
          <h1 className="platform-title">探究學習平台</h1>
          <button className="button switch-btn" onClick={() => setIsTeacher(!isTeacher)}>
            {isTeacher ? '切換到學生模式' : '切換到教師模式'}
          </button>
        </div>
      </header>
      <main className="main-content container" style={{position:'relative',overflow:'hidden'}}>
        {cloudSVG}
        <div className="section">
          <label>目前探究提問活動：</label>
          <select
            value={currentTopicIndex}
            onChange={e => setCurrentTopicIndex(Number(e.target.value))}
          >
            {topics.map((t, idx) => (
              <option key={t.id} value={idx}>{t.title}</option>
            ))}
          </select>
          {isTeacher && (
            <button className="button small ml-8" onClick={() => setIsAddingTopic(true)}>
              新增探究提問活動
            </button>
          )}
        </div>
        {isTeacher ? (
          <section>
            <div className="card">
              <h2>活動主題</h2>
              {topic && (
                <>
                  <input
                    className="input"
                    value={topic.title || ''}
                    onChange={e => {
                      if (!topics[currentTopicIndex]) return;
                      const updated = [...topics];
                      updated[currentTopicIndex].title = e.target.value;
                      setTopics(updated);
                    }}
                    placeholder="請輸入活動主題"
                  />
                  <textarea
                    className="textarea"
                    value={topic.description || ''}
                    onChange={e => {
                      if (!topics[currentTopicIndex]) return;
                      const updated = [...topics];
                      updated[currentTopicIndex].description = e.target.value;
                      setTopics(updated);
                    }}
                    placeholder="請輸入活動說明"
                  />
                </>
              )}
              <button 
                className="button"
                onClick={async () => {
                  try {
                    if (!topic.id) {
                      throw new Error('主題ID不存在');
                    }
                    
                    const response = await fetch(`/api/topics/${topic.id}`, {
                      method: 'PUT',
                      headers: { 
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                      },
                      body: JSON.stringify({
                        title: topic.title,
                        description: topic.description
                      })
                    });

                    if (!response.ok) {
                      const errorData = await response.json();
                      throw new Error(errorData.error || '更新失敗');
                    }

                    const updatedTopic = await response.json();
                    
                    // 更新本地状态
                    const updatedTopics = topics.map(t => 
                      t.id === topic.id ? { ...t, ...updatedTopic } : t
                    );
                    setTopics(updatedTopics);
                    
                    alert('更新成功！');
                  } catch (err) {
                    console.error('更新活動失敗:', err);
                    alert(err.message || '更新失敗，請重試');
                  }
                }}
              >
                儲存修改
              </button>
            </div>

            <div className="card">
              <div className="flex-between">
                <h2>學生問題管理</h2>
                <button className="button small" onClick={handleAIClassify}>AI 輔助分類</button>
              </div>
              <div className="tabs">
                {['全部問題', '未分類', ...fixedCategories].map(cat => (
                  <button
                    key={cat}
                    className={`tab ${tab === cat ? 'active' : ''}`}
                    onClick={() => setTab(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
              <ul className="question-list">
                {sortedQuestions.map((q, i) => (
                  <li key={i} className="question-item"
                    onMouseEnter={() => setMascotTip({ show: true, tip: isTeacher ? '可勾選分類或標註精選' : '這是同學的提問' })}
                    onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
                  >
                    <p><strong>{q.name} 的問題：</strong>{q.content}
                      {q.featured && <span className="featured-tag">精選</span>}
                    </p>
                    <div className="checkbox-group">
                      {fixedCategories.map(cat => (
                        <label key={cat}>
                          <input
                            type="checkbox"
                            checked={q.categories.includes(cat)}
                            onChange={() => handleCategoryChange(q.id, cat)}
                            onMouseEnter={() => setMascotTip({ show: true, tip: `勾選歸類為「${cat}」` })}
                            onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
                          />
                          {cat}
                        </label>
                      ))}
                      <button className={q.featured ? 'button small green-button' : 'button small'}
                        onClick={() => handleToggleFeatured(q.id)}
                        onMouseEnter={() => setMascotTip({ show: true, tip: q.featured ? '取消精選' : '標註為值得探究' })}
                        onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
                      >
                        {q.featured ? '★ 精選' : '☆ 精選'}
                      </button>
                      <span className="time">{q.time}</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </section>
        ) : (
          <section>
            <div className="card">
              <h2>活動主題</h2>
              <h3>{topic.title}</h3>
              <p className="description">{topic.description}</p>
            </div>

            <div className="card">
              <h2>提出你的問題</h2>
              <input
                className="input"
                placeholder="你的名字"
                value={studentName}
                onChange={(e) => setStudentName(e.target.value)}
                maxLength={20}
                required
                onMouseEnter={() => setMascotTip({ show: true, tip: '請輸入你的名字' })}
                onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
              />
              <textarea
                className="textarea"
                placeholder="請輸入你想問的問題…"
                value={studentQuestion}
                onChange={(e) => setStudentQuestion(e.target.value)}
                maxLength={200}
                required
                onMouseEnter={() => setMascotTip({ show: true, tip: '你可以這樣問：\n・為什麼…？\n・如果…會怎樣？\n・…和…有什麼不同？\n・你觀察到什麼現象？' })}
                onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
              />
              <div className="char-count">{studentQuestion.length}/200</div>
              <button 
                className="button" 
                onClick={handleSubmitQuestion}
                disabled={isSubmitting}
              >
                {isSubmitting ? '提交中...' : '提交問題'}
              </button>
              <button
                className="button small"
                style={{marginLeft: 8}}
                onClick={handleAISuggest}
                disabled={!studentQuestion.trim()}
              >
                請 AI 給建議
              </button>
            </div>

            <div className="card">
              <h2>班級問題集</h2>
              <div className="tabs">
                {['全部問題', '未分類', ...fixedCategories].map(cat => (
                  <button
                    key={cat}
                    className={`tab ${tab === cat ? 'active' : ''}`}
                    onClick={() => setTab(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
              {filterQuestions.length === 0 ? (
                <div className="empty-state">
                  <p>尚無問題</p>
                  <p className="empty-state-sub">快來提出你的第一個問題吧！</p>
                </div>
              ) : (
                <ul className="question-list">
                  {sortedQuestions.map((q, i) => (
                    <li key={i} className="question-item"
                      onMouseEnter={() => setMascotTip({ show: true, tip: '這是同學的提問' })}
                      onMouseLeave={() => setMascotTip({ show: false, tip: '' })}
                    >
                      <p><strong>{q.name} 的問題：</strong>{q.content}
                        {q.featured && <span className="featured-tag">精選</span>}
                      </p>
                      <div className="tag-container">
                        {q.categories.map(cat => (
                          <span key={cat} className="tag">{cat}</span>
                        ))}
                        <span className="time">{q.time}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>
        )}

        {isAddingTopic && (
          <div className="modal-overlay">
            <div className="modal">
              <h2>新增探究提問活動</h2>
              <input
                className="input"
                placeholder="活動名稱"
                value={newTopicTitle}
                onChange={e => setNewTopicTitle(e.target.value)}
                maxLength={50}
                required
              />
              <textarea
                className="textarea"
                placeholder="活動說明"
                value={newTopicDesc}
                onChange={e => setNewTopicDesc(e.target.value)}
                maxLength={500}
                required
              />
              <div className="inline-group">
                <button 
                  className="button green-button" 
                  onClick={handleModalSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? '提交中...' : '確定新增'}
                </button>
                <button 
                  className="button gray-button" 
                  onClick={() => setIsAddingTopic(false)}
                  disabled={isSubmitting}
                >
                  取消
                </button>
              </div>
            </div>
          </div>
        )}

        {toast.show && (
          <div className={`toast ${toast.type}`}>
            {toast.message}
          </div>
        )}

        {isTeacher && <StatisticsPanel questions={questions} />}
      </main>
      <footer className="main-footer" style={{position:'relative',overflow:'hidden'}}>
        {rainbowSVG}
        <div className="footer-content">
          <span>© 2024 探究學習平台 | Powered by 問題牆</span>
        </div>
      </footer>
      <MascotTooltip show={mascotTip.show} tip={mascotTip.tip} />
    </>
  );
}
